import $ from 'jquery';
import Api from '../utilities/Api';
import Popup from '../utilities/Popup';


$('body').on('submit', '.contacts-form', function (e) {
    e.preventDefault();
    const data = $(this).serializeArray().reduce((result, item) => {
        const newResult = { ...result };
        newResult[item.name] = item.value;
        return newResult;
    }, {});
    return Api.post('/api/consult/', data).then((response) => {
        Popup.notify(response.message);
    });
});
